<template>
  <div class="imgBox min-w-1400">
    <div class="imgBox1 min-w-1400">
      <div class="img1Box max-w-1400">
        <!-- <img :src="importedImg1" alt="" class="imgItem1" /> -->
      </div>
    </div>
    <div class="imgBox3 min-w-1400">
      <div class="img3Box max-w-1400">
        <p class="imgItem3">Chính sách quyền riêng tư của Canaan Tài</p>
        <!-- <img :src="importedImg2" alt="" class="imgItem2" /> -->
      </div>
    </div>
    <div class="imgBox2 min-w-1400">
      <div class="img2 max-w-1400">
        <!-- <h1>Cam kết bảo mật</h1> -->
        <!-- <div class="title-line"></div> -->
        <div class="textBox" style="white-space: pre-wrap">{{ text }}</div>
      </div>
    </div>
  </div>
</template>

<script>
// import importedImg1 from "@/page/passmorecompany/components/img/4_1.png";

export default {
  data() {
    return {
      altText: "protocolTitle",
      // importedImg1: importedImg1,
      text: `Theo Nghị định số 13/2023/NĐ-CP về bảo vệ dữ liệu cá nhân và các quy định pháp luật hiện hành tại Việt Nam, CANAAN GROUP TRADING SERVICE COMPANY LIMITED-CAFOOD BRANCH (sau đây gọi là “công ty”) xin thông báo đến người dùng (sau đây gọi là “Người dùng”) về việc thu thập, sử dụng và xử lý dữ liệu cá nhân như sau:
Canaan Tài là ứng dụng được phát triển và vận hành bởi CANAAN GROUP TRADING SERVICE COMPANY LIMITED-CAFOOD BRANCH.
1. Đơn vị chịu trách nhiệm về dữ liệu cá nhân
CANAAN GROUP TRADING SERVICE COMPANY LIMITED-CAFOOD BRANCH có địa chỉ tại:
99/4 Đường HT35, Khu phố 1, Phường Hiệp Thành, Quận 12, TP. Hồ Chí Minh, Việt Nam,
chịu trách nhiệm trong việc thu thập, lưu trữ, sử dụng, tiết lộ, truyền tải hoặc xử lý dữ liệu cá nhân nhằm cung cấp dịch vụ tài chính qua nền tảng Canaan Tài.
2. Phạm vi thu thập dữ liệu cá nhân
Canaan Tài thu thập dữ liệu cá nhân của Người dùng nhằm mục đích thẩm định tín dụng, cung cấp khoản vay, chăm sóc khách hàng và cải thiện chất lượng dịch vụ.
a) Thu thập trực tiếp:
Thông tin được Người dùng cung cấp trực tiếp khi:
Đăng ký tài khoản hoặc sử dụng dịch vụ qua ứng dụng hoặc website.
Tham gia các chương trình khuyến mãi, sự kiện, hoặc gửi yêu cầu hỗ trợ.
Liên hệ qua cuộc gọi, mạng xã hội hoặc ứng dụng nhắn tin.
b) Thu thập gián tiếp:
Thông tin được thu thập từ:
Các nguồn dữ liệu công khai hoặc bên thứ ba được phép chia sẻ.
Dữ liệu do Người dùng để lại trên mạng xã hội, email, số điện thoại hoặc nền tảng có liên kết với Canaan Tài.
Các cơ quan có thẩm quyền như Trung tâm Thông tin Tín dụng Quốc gia (CIC) để phục vụ đánh giá tín dụng.
Toàn bộ dữ liệu sẽ được xử lý theo quy định của pháp luật và được bảo mật theo tiêu chuẩn phù hợp nhằm bảo vệ quyền lợi hợp pháp của Người dùng.

2. Xử lý thông tin cá nhân và dữ liệu nhạy cảm do người dùng cung cấp
Canaan Tài cam kết thu thập và xử lý thông tin cá nhân của người dùng một cách hợp pháp, minh bạch và đúng mục đích theo quy định pháp luật hiện hành tại Việt Nam. Các loại dữ liệu có thể được thu thập bao gồm:
2.1 Dữ liệu nhận dạng cá nhân:
Họ và tên
Ngày sinh
Giới tính
Tình trạng hôn nhân
Mã số định danh cá nhân (CMND/CCCD, mã số thuế, mã số bảo hiểm xã hội hoặc mã số định danh cá nhân khác nếu có)
Ảnh chụp giấy tờ tùy thân và ảnh chân dung (selfie)
Chữ ký, giọng nói hoặc hình ảnh được thu thập qua cơ chế ghi âm/ghi hình được người dùng cho phép.
Việc ghi âm, ghi hình hoặc lưu trữ dữ liệu sinh trắc học chỉ được thực hiện khi có sự đồng ý rõ ràng của Người dùng, phục vụ cho quá trình xác minh và cung cấp sản phẩm tài chính. Dữ liệu này có thể được sao lưu để tuân thủ quy định pháp lý.
2.2 Thông tin liên hệ:
Địa chỉ email
Số điện thoại di động và cố định
Địa chỉ nơi cư trú
2.3 Dữ liệu tài chính:
Thông tin thẻ ngân hàng (số thẻ, tên chủ thẻ, mã bảo mật nếu được phép)
Thu nhập hàng tháng
Ngày nhận lương
Chi tiêu trung bình hàng tháng
Số lượng tài khoản ngân hàng, số dư, lịch sử giao dịch
Loại hình nhà ở và thời gian cư trú
2.4 Thông tin nghề nghiệp và học vấn:
Tên công ty đang làm việc
Chức vụ
Ngành nghề
Địa chỉ nơi làm việc
Trình độ học vấn cao nhất
Thời gian bắt đầu công việc hiện tại và công việc trước đó
2.5 Dữ liệu hành vi trên internet và thiết bị:
Lịch sử truy cập website hoặc ứng dụng
Địa chỉ IP
Thời gian sử dụng, tần suất truy cập
Hệ điều hành, thiết bị sử dụng, phiên bản ứng dụng
Cookie và dữ liệu định danh khác
2.6 Dữ liệu từ bên thứ ba do người dùng cung cấp:
Thông tin người phụ thuộc
Người tham khảo hoặc người được giới thiệu: họ tên, số điện thoại, mối quan hệ với người dùng
2.7 Hành vi sử dụng điện thoại và dữ liệu dịch vụ di động:
Nhà mạng sử dụng
Chi phí sử dụng dịch vụ và gói cước
Tần suất nạp tiền, lịch sử tiêu dùng dịch vụ
Ứng dụng thường sử dụng
Thông tin thiết bị: hãng, model điện thoại khi người dùng đăng ký khoản vay
2.8 Dữ liệu bổ sung khi sử dụng ứng dụng:
Vị trí địa lý thời gian thực
Truy cập danh bạ (nếu được người dùng cấp quyền)
Dữ liệu phần cứng, phần mềm, và mức độ sử dụng mạng Internet
Dữ liệu từ các dịch vụ kết nối (ví dụ: dịch vụ định vị, dịch vụ phân tích ứng dụng)
Tất cả dữ liệu trên được thu thập phục vụ cho việc:
Đánh giá khả năng tín dụng
Thẩm định khoản vay
Phân tích hành vi người dùng nhằm nâng cao trải nghiệm
Phòng chống gian lận và tuân thủ yêu cầu pháp lý
Canaan Tài luôn áp dụng các biện pháp kỹ thuật và tổ chức phù hợp để đảm bảo an toàn, bảo mật và tính toàn vẹn của thông tin cá nhân Người dùng trong suốt quá trình xử lý.
2.9 Dữ liệu sinh trắc học và dữ liệu nhạy cảm
Canaan Tài có thể thu thập và xử lý dữ liệu sinh trắc học của Người dùng trong trường hợp được cấp quyền rõ ràng, cụ thể và hợp pháp, nhằm phục vụ mục đích xác thực danh tính và bảo mật thông tin khi sử dụng dịch vụ.
Dữ liệu sinh trắc học có thể bao gồm, nhưng không giới hạn ở:
Dấu vân tay
Nhận diện khuôn mặt
Hình ảnh võng mạc hoặc mống mắt
Dữ liệu hành vi có thể xác định cá nhân (nếu được phép)
Thông tin này chỉ được sử dụng để đối chiếu trong hệ thống xác thực sinh trắc học và phục vụ cho việc đảm bảo an toàn, chống giả mạo và ngăn chặn gian lận trong quy trình đăng ký khoản vay.
Canaan Tài không chủ động thu thập bất kỳ dữ liệu nào có thể bị xem là "nhạy cảm" theo quy định pháp luật Việt Nam, bao gồm nhưng không giới hạn ở các thông tin về:
Quan điểm chính trị
Tôn giáo hoặc tín ngưỡng
Tình trạng sức khỏe hoặc đời sống tình dục
Thông tin về dân tộc hoặc nguồn gốc chủng tộc
Thành viên công đoàn, đảng phái hoặc tổ chức chính trị
Chúng tôi yêu cầu Người dùng không cung cấp bất kỳ dữ liệu nào nêu trên. Trường hợp Canaan Tài nhận được dữ liệu nhạy cảm trong quá trình sử dụng dịch vụ, chúng tôi cam kết:
Chỉ xử lý dữ liệu này nếu thực sự cần thiết để duy trì quan hệ cung cấp dịch vụ, và
Áp dụng các biện pháp bảo vệ phù hợp theo đúng quy định của pháp luật hiện hành
Nếu không cần thiết, dữ liệu sẽ được xóa khỏi hệ thống một cách an toàn và đúng quy trình pháp lý.
Mọi hoạt động ký tên và xác thực danh tính thực hiện qua nền tảng Canaan Tài được hiểu là Người dùng đã đồng ý cho phép xử lý dữ liệu cá nhân tương ứng.
Trong trường hợp Người dùng cung cấp thông tin cá nhân của bên thứ ba (bao gồm người tham chiếu, người được giới thiệu, người thụ hưởng hoặc chủ thẻ khác), Người dùng có trách nhiệm:
Thông báo rõ ràng cho bên thứ ba về việc chia sẻ thông tin,
Giải thích mục đích sử dụng,
Và đảm bảo rằng việc cung cấp thông tin đó là hợp pháp theo quy định.
Tất cả dữ liệu được thu thập nhằm mục đích phục vụ quá trình thẩm định tín dụng, cung cấp khoản vay, đảm bảo an toàn giao dịch và cải thiện dịch vụ.
2.10 Quyền truy cập tin nhắn SMS (chỉ đọc):
Được sử dụng để phân tích thông tin giao dịch tài chính từ tin nhắn ngân hàng hoặc nhà mạng nhằm đánh giá khả năng tín dụng. Canaan Tài không truy cập vào tin nhắn cá nhân hoặc tin nhắn không liên quan.
2.11 Quyền truy cập máy ảnh:
Dùng để chụp ảnh giấy tờ tùy thân hoặc ảnh chân dung (selfie) nhằm xác minh danh tính Người dùng trong quá trình đăng ký.
2.12 Quyền truy cập vị trí (chỉ ở mức gần đúng - approximate location):
Giúp xác định vùng địa lý chung của Người dùng để hỗ trợ phát hiện hoạt động bất thường, phòng chống gian lận và phục vụ báo cáo phân tích.
2.13 Quyền truy cập lịch (Calendar):
Có thể được sử dụng để hỗ trợ đặt lời nhắc thanh toán hoặc hiển thị lịch sử giao dịch nếu Người dùng đồng ý. Ứng dụng không đọc, chia sẻ hoặc lưu trữ bất kỳ nội dung lịch cá nhân nào ngoài các chức năng liên quan đến dịch vụ tín dụng.
2.14 Quyền truy cập danh sách ứng dụng đã cài đặt (App List):
Giúp hệ thống đánh giá hành vi sử dụng điện thoại và phát hiện các ứng dụng có nguy cơ rủi ro cao, từ đó hỗ trợ quá trình thẩm định tín dụng chính xác hơn.
Việc truy cập các quyền trên chỉ được thực hiện sau khi có sự đồng ý rõ ràng từ Người dùng, tuân thủ quy định bảo vệ dữ liệu cá nhân của pháp luật Việt Nam. Tất cả dữ liệu liên quan sẽ được xử lý, lưu trữ và bảo mật theo quy định.
 
3. Mục đích thu thập và xử lý dữ liệu cá nhân
Việc thu thập dữ liệu cá nhân của Người dùng bởi Canaan Tài – được phát triển và vận hành bởi CANAAN GROUP TRADING SERVICE COMPANY LIMITED-CAFOOD BRANCH – nhằm phục vụ hai mục đích chính:
a) Mục đích chính (Phục vụ quan hệ hợp đồng và cung cấp dịch vụ)
Xác minh và xác thực danh tính Người dùng (trực tiếp hoặc thông qua bên thứ ba có thẩm quyền trong và ngoài nước).
Đánh giá khả năng tín dụng và phân tích rủi ro để ra quyết định cấp khoản vay.
Ký kết và thực hiện các hợp đồng vay vốn hoặc các dịch vụ tài chính khác do Canaan Tài cung cấp.
Phòng chống gian lận, hành vi vi phạm pháp luật hoặc hành vi có dấu hiệu rủi ro (có thể thông qua bên thứ ba nội địa hoặc quốc tế).`,
    };
  },
};
</script>

<style scoped>
.imgBox {
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
}

.imgBox1 {
  display: flex;
  justify-content: center;
  width: 100%;
  min-width: 1400px;
  background-color: "";
}

.imgBox2 {
  display: flex;
  justify-content: center;
  max-width: 1400px;
  padding-top: 40px;
  padding-bottom: 20px;
  height: 3200px;
  background-color: #ffffff;
  border-radius: 32px;
  margin: -140px auto 150px;
}

.imgBox3 {
  display: flex;
  justify-content: center;
  width: 100%;
  min-width: 1400px;
  background-color: "";
}

img {
  display: block;
}

.img1 {
  overflow: hidden;
  width: 100%;
}

.img2,
.img4 {
  overflow: hidden;
}

.img3 {
  width: 100%;
  overflow: hidden;
  margin-left: 0;
  margin-right: 0;
}

.imgItem1 {
  width: 100%;
  margin-top: 0;
  margin-bottom: 0;
}

.imgItem2 {
  max-width: 100%;
}

.imgItem3 {
  width: 100%;
  overflow: hidden;
  margin-left: 0;
  margin-right: 0;
}

h1 {
  margin-top: 50px;
  margin-left: 490px;
  color: #000000;
  font-size: 40px;
  /* border-bottom: 5px solid #04358A; */
  display: inline-block;
}

.textBox {
  margin-top: 50px;
  margin-left: 100px;
  margin-right: 100px;
  font-size: 18px;
  color: #000000;
}

.imgBox2 {
  transform: scale(90%);
  /* transform: scale(80%); */
  margin: -200px auto 100px;
  height: 3800px;
  /* box-shadow: 0 1px 4.8px 0px rgba(0, 0, 0, 0.25); */
  /* border: 2px solid #F6660B; */
}
.textBox {
  margin-top: 20px;
  margin-left: 50px;
  margin-right: 50px;
}
/* .imgBox2{
  border-radius: 0;
  border-top: 3px solid #7c2af8;
  border-left: 2px solid #e9e9e9;
  border-right: 2px solid #e9e9e9;
  border-bottom: 3px solid #c1c1c1;
} */
.title-line {
  width: 430px;
  /* background: url(./components/img/Group1.png); */
  /* background-repeat: no-repeat; */
  /* background-position: -150px 10px; */
  /* height: 50px; */
  /* border: 1px solid red; */
  border: 2px solid #4D64E4;
  margin: 0 500px;
}

.img1 {
  /* background: radial-gradient(57.03% 57.03% at 50% 50%, #3C51A0 0%, #223479 100%); */
  height: 291px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.imgItem1 {
  color: #333333;
  font-family: "SF Pro Display";
  font-weight: 700;
  font-size: 34px;
  text-align: center;
}
.img1Box,
.img3Box {
  margin: 0;
  overflow: hidden;
  width: 100%;
  padding: 0 200px 50px;
}

.img1Box {
  height: 300px;
  flex-shrink: 0;
  background: #4D64E4;
}
.img3Box {
  margin-top: -200px;
  padding: 0 150px 50px;
  border-radius: 32px 32px 0 0;
  /* background-color: white; */
}

.imgItem3 {
  color: #333333;
  text-align: center;
  font-family: "SF Pro";
  font-size: 46px;
  font-style: normal;
  font-weight: 600;
  line-height: 42.67px;
  letter-spacing: 0.13px;
  background-color: white;
  border-radius: 32px 32px 0 0;
  padding: 100px 50px 20px;
}
.imgItem3::after {
  content: "";
  display: block;
  width: 440px;
  height: 12px;
  border-radius: 12px;
  background: #4D64E4;
  margin: 20px auto 20px;
}
</style>
